import type { HTMLAttributes } from "react";

import { cn } from "../../cn";

/**
 * Placeholder de carregamento — variante **web**.
 *
 * A irmã nativa está ao lado, em `skeleton.native.tsx`. As duas dividem o número do
 * pulso (`PULSE`, no `@tami/tokens`) e nada mais: aqui é a keyframe CSS do
 * Tailwind, lá é Reanimated. A técnica não atravessa; a medida sim.
 *
 * O desktop consome esta, não uma terceira: ele é webview e roda React DOM.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />
  );
}
